import $ from 'jquery';

$(() => {
    const formID = `forminator-module-${window.sage.contactFormId}`;
    const $form = $(`#${formID}`);

    if (!$form.length) {
        return;
    }

    const storeSelectedTitle = window.sage.userStoreTitle;
    const storeSelectedEmail = window.sage.userStoreEmail;
    const contactFormStoreSelectFieldID =
        window.sage.contactFormStoreSelectFieldID;
    const contactFormStoreEmailFieldID =
        window.sage.contactFormStoreEmailFieldID;

    const $storeSelectField = $form.find(
        `input[name="${contactFormStoreSelectFieldID}"]`
    );

    const $storeEmailField = $form.find(
        `input[name="${contactFormStoreEmailFieldID}"]`
    );

    $storeSelectField.val(storeSelectedTitle);
    $storeEmailField.val(storeSelectedEmail);
});
